"use client";

import {PolarAngleAxis, PolarGrid, PolarRadiusAxis, Radar, RadarChart, ResponsiveContainer} from "recharts";

export default function TDBChart({dataValue}){

    const data = [
        {
            subject: 'Cardio',
            A: 120,
            B: 110,
            fullMark: 150,
        },
        {
            subject: 'Profil Nerveux',
            A: 98,
            B: 130,
            fullMark: 150,
        },
        {
            subject: 'Musculaire',
            A: 86,
            B: 130,
            fullMark: 150,
        },
        {
            subject: 'Souplesse',
            A: 99,
            B: 100,
            fullMark: 150,
        },
        {
            subject: 'Équilibre',
            A: 85,
            B: 90,
            fullMark: 150,
        },
    ];
    console.log(dataValue);
    return(
        <ResponsiveContainer width={"100%"} height={250}>
            <RadarChart data={dataValue} margin={{top: 20, right: 10, bottom: 20, left: 10}}>
                <PolarGrid />
                <PolarAngleAxis dataKey="subject" />
                <Radar name="Mike" dataKey="A" stroke="#facc15" fill="#facc15" fillOpacity={0.6} />
            </RadarChart>
        </ResponsiveContainer>
    )
}